module.exports = __webpack_public_path__ + "img/CN-注册3.117b20b2.png";